import { useEffect } from 'react';
import { BAR_HEIGHT_PX } from '../constants';

const CSS_VAR = '--agentforge-bottom-gutter';
// Bar height + a small breathing space so route content
// (pagination/footers) doesn't kiss the bar's top border.
const GUTTER_PX = BAR_HEIGHT_PX;

// Sets a CSS variable on <html> while the bar is visible. The app shell's
// main element reads `padding-bottom: var(--agentforge-bottom-gutter, 0px)`
// so route content (lists, pagination, footers) always reserves space for
// the docked bar instead of rendering underneath it.
export const useReserveBottomBarSpace = (visible: boolean): void => {
  useEffect(() => {
    if (!visible) return undefined;
    const root = document.documentElement;
    root.style.setProperty(CSS_VAR, `${GUTTER_PX}px`);
    return () => {
      root.style.removeProperty(CSS_VAR);
    };
  }, [visible]);
};
